var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import axios from 'axios';
import { Product } from '../Models/Product';
import { Order, OrdersCount } from '../Models/Order';
import { InkyApiV2 } from './InkyApiV2';
import { Article } from '../Models/Article';
import Axios from 'axios';
import Log from '../Kodansha/Services/Logger';
export var DEFAULT_API_VERSION = '1.4';
var AccountSetting = /** @class */ (function () {
    function AccountSetting(_key, _value) {
        this.key = _key;
        this.value = _value;
    }
    return AccountSetting;
}());
export var InkyApiStatus;
(function (InkyApiStatus) {
    InkyApiStatus["NotFound"] = "NotFound";
    InkyApiStatus["Default"] = "Default";
})(InkyApiStatus || (InkyApiStatus = {}));
var InkyApiError = /** @class */ (function (_super) {
    __extends(InkyApiError, _super);
    function InkyApiError(msg, status) {
        var _this = _super.call(this, msg) || this;
        _this.status = status;
        Object.setPrototypeOf(_this, InkyApiError.prototype);
        return _this;
    }
    return InkyApiError;
}(Error));
export { InkyApiError };
var InkyAPI = /** @class */ (function () {
    function InkyAPI() {
        // Get the baseURL from the environment-variables.
        this.apiBaseUrl = process.env.REACT_APP_BASE_URL;
    }
    /**
     * Gets the accessToken from the authState, and checks if its expired.
     * @returns string of accessToken is found and valid. null if not found or invalid.
     */
    InkyAPI.prototype.getAccessToken = function () {
        return InkyApiV2.shared().AccessToken;
    };
    InkyAPI.prototype.get = function (url, cancelTokenSource, params, apiVersion) {
        var e_1, _a;
        var token = this.getAccessToken(); // authClient.getAccessToken();
        var fullUrl = new URL(url, this.apiBaseUrl);
        if (params) {
            var param = void 0;
            try {
                for (var params_1 = __values(params), params_1_1 = params_1.next(); !params_1_1.done; params_1_1 = params_1.next()) {
                    param = params_1_1.value;
                    fullUrl.searchParams.append(param[0], param[1]);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (params_1_1 && !params_1_1.done && (_a = params_1.return)) _a.call(params_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        //console.log({desc:"Rhubarb", token:token, baseUrl: this.baseURL, subUrl: url, fullUrl: fullUrl.href});
        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
        return axios.get(fullUrl.href, {
            headers: {
                Authorization: "Bearer ".concat(token),
            },
            cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
        });
    };
    InkyAPI.prototype.getV2 = function (url, params, apiVersion) {
        var e_2, _a;
        var token = this.getAccessToken(); // authClient.getAccessToken();
        var fullUrl = new URL(url, this.apiBaseUrl);
        if (params) {
            var param = void 0;
            try {
                for (var params_2 = __values(params), params_2_1 = params_2.next(); !params_2_1.done; params_2_1 = params_2.next()) {
                    param = params_2_1.value;
                    fullUrl.searchParams.append(param[0], param[1]);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (params_2_1 && !params_2_1.done && (_a = params_2.return)) _a.call(params_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
        return axios.get(fullUrl.href, { headers: { Authorization: "Bearer ".concat(token) } })
            .then(function (response) {
            return response.data;
        })
            .catch(function (error) {
            throw error;
        });
    };
    InkyAPI.prototype.getV3 = function (url, accessToken, params, apiVersion) {
        var e_3, _a;
        if (accessToken === void 0) { accessToken = null; }
        var fullUrl = new URL(url, this.apiBaseUrl);
        if (params) {
            var param = void 0;
            try {
                for (var params_3 = __values(params), params_3_1 = params_3.next(); !params_3_1.done; params_3_1 = params_3.next()) {
                    param = params_3_1.value;
                    fullUrl.searchParams.append(param[0], param[1]);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (params_3_1 && !params_3_1.done && (_a = params_3.return)) _a.call(params_3);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
        return axios.get(fullUrl.href, { headers: { Authorization: "Bearer ".concat(accessToken) } })
            .then(function (response) {
            return response.data;
        })
            .catch(function (error) {
            throw error;
        });
    };
    InkyAPI.prototype.getV4 = function (url, abortSignal, params, apiVersion) {
        var e_4, _a;
        var accessToken = this.getAccessToken();
        var fullUrl = new URL(url, this.apiBaseUrl);
        if (params) {
            var param = void 0;
            try {
                for (var params_4 = __values(params), params_4_1 = params_4.next(); !params_4_1.done; params_4_1 = params_4.next()) {
                    param = params_4_1.value;
                    fullUrl.searchParams.append(param[0], param[1]);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (params_4_1 && !params_4_1.done && (_a = params_4.return)) _a.call(params_4);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
        return axios.get(fullUrl.href, { signal: abortSignal, headers: { Authorization: "Bearer ".concat(accessToken) } })
            .then(function (response) {
            return response.data;
        })
            .catch(function (error) {
            throw error;
        });
    };
    //ToDo: Payload should be any, not T. T is the return type.
    InkyAPI.prototype.post = function (url, payload, cancelTokenSource, apiVersion) {
        var token = this.getAccessToken(); // authClient.getAccessToken();
        var fullUrl = new URL(url, this.apiBaseUrl);
        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
        return axios.post(fullUrl.href, payload, {
            headers: {
                Authorization: "Bearer ".concat(token),
            },
            cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
        });
    };
    InkyAPI.prototype.postV2 = function (url, payload, cancelTokenSource, apiVersion) {
        var token = this.getAccessToken(); // authClient.getAccessToken();
        var fullUrl = new URL(url, this.apiBaseUrl);
        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
        return axios.post(fullUrl.href, payload, {
            headers: {
                Authorization: "Bearer ".concat(token),
                'content-type': 'text/json',
            },
            cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
        });
    };
    /**
     *  T is payload type, U is return type
     * @param url
     * @param payload
     * @param abortSignal
     */
    InkyAPI.prototype.postV4 = function (url, payload, abortSignal, apiVersion) {
        var token = this.getAccessToken();
        var fullUrl = new URL(url, this.apiBaseUrl);
        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
        return (axios.post(fullUrl.href, payload, {
            headers: {
                Authorization: "Bearer ".concat(token),
                'content-type': 'text/json',
            },
            signal: abortSignal
        })).then(function (res) { return res.data; });
    };
    InkyAPI.prototype.postForm = function (url, params, apiVersion) {
        var fullUrl = new URL(url, this.apiBaseUrl);
        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
        return axios.post(fullUrl.href, this.getFormData(params), this.getAuthorizedConfig());
    };
    InkyAPI.prototype.postData = function (url, data, params, apiVersion) {
        var fullUrl = new URL(url, this.apiBaseUrl);
        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
        var formData = this.getFormData(params);
        formData.append('file', data);
        return axios.post(fullUrl.href, formData, this.getAuthorizedConfig());
    };
    InkyAPI.prototype.getAuthorizedConfig = function () {
        var token = this.getAccessToken(); // authClient.getAccessToken();
        return {
            headers: {
                'Authorization': "Bearer ".concat(token),
            },
        };
    };
    InkyAPI.prototype.getFormData = function (params) {
        var formData = new FormData();
        if (params) {
            for (var i = 0; i < params.length; i++) {
                formData.append(params[i][0], params[i][1]);
            }
        }
        return formData;
    };
    InkyAPI.prototype.patch = function (url, payload, cancelTokenSource, apiVersion) {
        var token = this.getAccessToken(); // auth0Client.getAccessToken();
        var fullUrl = new URL(url, this.apiBaseUrl);
        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
        return axios.patch(fullUrl.href, payload, {
            headers: {
                Authorization: "Bearer ".concat(token),
            },
            cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
        });
    };
    // delete(url: string): Promise<AxiosResponse<void>> {
    //     const token = this.getAccessToken(); // authClient.getAccessToken();
    //     return axios.delete(this.apiBaseUrl + url, {
    //         headers: {
    //             Authorization: `Bearer ${token}`,
    //         },
    //     });
    // }
    //region Response-fetchers for new endpoints
    InkyAPI.prototype.getResponse = function (url, cancelTokenSource, params, apiVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var token, fullUrl, param, params_5, params_5_1, response, err_1;
            var e_5, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        token = this.getAccessToken();
                        fullUrl = new URL(url, this.apiBaseUrl);
                        if (params) {
                            param = void 0;
                            try {
                                for (params_5 = __values(params), params_5_1 = params_5.next(); !params_5_1.done; params_5_1 = params_5.next()) {
                                    param = params_5_1.value;
                                    fullUrl.searchParams.append(param[0], param[1]);
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (params_5_1 && !params_5_1.done && (_a = params_5.return)) _a.call(params_5);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                        }
                        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.get(fullUrl.href, {
                                headers: {
                                    Authorization: "Bearer ".concat(token),
                                },
                                cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
                            })];
                    case 2:
                        response = _b.sent();
                        return [2 /*return*/, response.data];
                    case 3:
                        err_1 = _b.sent();
                        Log.error("Request failed", err_1);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Using new Signal property, see: https://axios-http.com/docs/cancellation
     * @param url
     * @param abortSignal see: https://developer.mozilla.org/en-US/docs/Web/API/AbortController
     * @param params
     */
    InkyAPI.prototype.getResponseV2 = function (url, abortSignal, params, apiVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var token, fullUrl, param, params_6, params_6_1, response, err_2;
            var e_6, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        token = this.getAccessToken();
                        fullUrl = new URL(url, this.apiBaseUrl);
                        if (params) {
                            param = void 0;
                            try {
                                for (params_6 = __values(params), params_6_1 = params_6.next(); !params_6_1.done; params_6_1 = params_6.next()) {
                                    param = params_6_1.value;
                                    fullUrl.searchParams.append(param[0], param[1]);
                                }
                            }
                            catch (e_6_1) { e_6 = { error: e_6_1 }; }
                            finally {
                                try {
                                    if (params_6_1 && !params_6_1.done && (_a = params_6.return)) _a.call(params_6);
                                }
                                finally { if (e_6) throw e_6.error; }
                            }
                        }
                        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.get(fullUrl.href, {
                                headers: {
                                    Authorization: "Bearer ".concat(token),
                                },
                                signal: abortSignal ? abortSignal : null,
                            })];
                    case 2:
                        response = _b.sent();
                        return [2 /*return*/, response.data];
                    case 3:
                        err_2 = _b.sent();
                        Log.error("Request failed", err_2);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    InkyAPI.prototype.getData = function (url, params, apiVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var token, fullUrl, param, params_7, params_7_1, response, apiResponse;
            var e_7, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        token = this.getAccessToken();
                        fullUrl = new URL(url, this.apiBaseUrl);
                        if (params) {
                            param = void 0;
                            try {
                                for (params_7 = __values(params), params_7_1 = params_7.next(); !params_7_1.done; params_7_1 = params_7.next()) {
                                    param = params_7_1.value;
                                    fullUrl.searchParams.append(param[0], param[1]);
                                }
                            }
                            catch (e_7_1) { e_7 = { error: e_7_1 }; }
                            finally {
                                try {
                                    if (params_7_1 && !params_7_1.done && (_a = params_7.return)) _a.call(params_7);
                                }
                                finally { if (e_7) throw e_7.error; }
                            }
                        }
                        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
                        return [4 /*yield*/, axios.get(fullUrl.href, {
                                headers: {
                                    Authorization: "Bearer ".concat(token),
                                },
                            })];
                    case 1:
                        response = _b.sent();
                        apiResponse = response.data;
                        if (apiResponse.status.type == 'NotFound') {
                            throw new InkyApiError('Object does not exist in backend', InkyApiStatus.NotFound);
                        }
                        return [2 /*return*/, apiResponse.response];
                }
            });
        });
    };
    InkyAPI.prototype.postResponse = function (url, payload, cancelTokenSource, apiVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var token, fullUrl, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = this.getAccessToken();
                        fullUrl = new URL(url, this.apiBaseUrl);
                        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
                        return [4 /*yield*/, axios.post(fullUrl.href, payload, {
                                headers: {
                                    Authorization: "Bearer ".concat(token),
                                },
                                cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    InkyAPI.prototype.patchResponse = function (url, payload, cancelTokenSource, apiVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var token, fullUrl, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = this.getAccessToken();
                        fullUrl = new URL(url, this.apiBaseUrl);
                        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
                        return [4 /*yield*/, axios.patch(fullUrl.href, payload, {
                                headers: {
                                    Authorization: "Bearer ".concat(token),
                                },
                                cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    InkyAPI.prototype.getFile = function (url, payload, cancelTokenSource, apiVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var token, fullUrl, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = this.getAccessToken();
                        fullUrl = new URL(url, this.apiBaseUrl);
                        fullUrl.searchParams.append("api-version", apiVersion !== null && apiVersion !== void 0 ? apiVersion : DEFAULT_API_VERSION);
                        return [4 /*yield*/, axios.post(fullUrl.href, payload, {
                                headers: {
                                    Authorization: "Bearer ".concat(token),
                                },
                                cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
                                responseType: 'blob'
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    //endregion
    /* CONTENT */
    InkyAPI.prototype.getHome = function (platform, cancelTokenSource) {
        return this.get("/home/V2/?platform=".concat(platform), cancelTokenSource);
    };
    InkyAPI.prototype.getSpotlight = function () {
        return this.get("/spotlight");
    };
    InkyAPI.prototype.getPlan = function (cancelTokenSource) {
        return this.get("/plan", cancelTokenSource);
    };
    InkyAPI.prototype.getPages = function (comicId, cancelTokenSource) {
        var url = "/comic/".concat(comicId, "/pages");
        return this.get(url, cancelTokenSource);
    };
    InkyAPI.prototype.getMyComics = function (userid, cancelTokenSource) {
        var url = "/mycomics";
        return this.get(url, cancelTokenSource);
    };
    InkyAPI.prototype.getMyBooks = function (cancelTokenSource) {
        var url = '/mycomics/';
        return this.get(url, cancelTokenSource);
    };
    InkyAPI.prototype.getMyPurchasedBooks = function (cancelTokenSource) {
        var url = '/mycomics?withReadingProgress=false';
        return this.get(url, cancelTokenSource);
    };
    InkyAPI.prototype.getMyProcessingBooks = function (cancelTokenSource) {
        var url = '/mycomics/processing';
        return this.get(url, cancelTokenSource);
    };
    InkyAPI.prototype.getReadingProgress = function (cancelTokenSource) {
        var url = '/mycomics/withReadingProgress';
        return this.get(url, cancelTokenSource);
    };
    InkyAPI.prototype.addToMyComics = function (userid, id, cancelTokenSource) {
        var url = "/mycomics/".concat(userid, "/").concat(id);
        return this.post(url, null, cancelTokenSource);
    };
    InkyAPI.prototype.removeFromMyComics = function (userid, id, cancelTokenSource) {
        var url = "/mycomics/remove/".concat(userid, "/").concat(id);
        return this.patch(url, null, cancelTokenSource);
    };
    InkyAPI.prototype.setUserReadingProgress = function (userID, ucd, cancelTokenSource) {
        var url = "/mycomics/".concat(userID);
        return this.patch(url, ucd, cancelTokenSource);
    };
    InkyAPI.prototype.getCarousel = function (cancelTokenSource) {
        return this.get('/discover/carousel/V3', cancelTokenSource);
    };
    //ToDO: Change to DiscoverItem[]
    InkyAPI.prototype.getDiscover = function (currentType, currentSort, currentGenre, includeSeries, subCategory, cancelTokenSource, start, count, widths, publishStatus) {
        var url = '/discover/v2';
        var params = [];
        if (currentType > -1)
            params.push('type=' + currentType);
        if (currentSort > -1)
            params.push('sort=' + currentSort);
        if (currentGenre > -1)
            params.push('genreIds=' + currentGenre);
        if (subCategory !== '')
            params.push('subCategory=' + subCategory);
        params.push('includeSeries=' + includeSeries);
        if (widths > -1)
            params.push('widths=' + widths);
        if (publishStatus > -1)
            params.push('publishStatus=' + publishStatus);
        if (start != null) {
            params.push("fromIndex=".concat(start.valueOf()));
            if (count && count > -1)
                params.push("count=".concat(count.valueOf()));
        }
        if (params.length > 0) {
            url += '?' + params.filter(function (p) { return !p.endsWith("null"); }).join('&');
        }
        console.log(url);
        return this.getResponse(url, cancelTokenSource);
    };
    InkyAPI.prototype.newReleaseCalendar = function (type) {
        return this.getResponse('/product/ReleaseCalendar?filterBy=' + type);
    };
    InkyAPI.prototype.getDiscoverVariant = function (currentType, currentSort, currentGenre, includeSeries, subCategory, cancelTokenSource, start, count, widths, publishStatus, newOnly, ageRatings, seriesStatus, isFree) {
        var url = '/product/getPlanned';
        var params = [];
        if (currentType > -1)
            params.push('type=' + currentType);
        if (currentSort > -1)
            params.push('sort=' + currentSort);
        if ((currentGenre === null || currentGenre === void 0 ? void 0 : currentGenre.length) > 0)
            params.push('genreIds=' + currentGenre);
        if (subCategory !== '')
            params.push('subCategory=' + subCategory);
        params.push('includeSeries=' + includeSeries);
        if (widths > -1)
            params.push('widths=' + widths);
        if (publishStatus > -1)
            params.push('publishStatus=' + publishStatus);
        if (newOnly)
            params.push('newOnly=' + newOnly);
        if (isFree)
            params.push('isFree=' + isFree);
        if ((ageRatings === null || ageRatings === void 0 ? void 0 : ageRatings.length) > 0)
            params.push('ageRating=' + ageRatings);
        if (seriesStatus > -1)
            params.push('seriesStatus=' + seriesStatus);
        if (start != null) {
            params.push("fromIndex=".concat(start.valueOf()));
            if (count && count > -1)
                params.push("count=".concat(count.valueOf()));
        }
        if (params.length > 0) {
            url += '?' + params.filter(function (p) { return !p.endsWith("null"); }).join('&');
        }
        Log.debug(url);
        return this.getResponse(url, cancelTokenSource);
    };
    InkyAPI.prototype.getDiscoverV2 = function (currentType, currentSort, currentGenre, includeSeries, subCategory, cancelTokenSource, start, count, widths, scheduleStatus, newOnly, ageRatings, seriesStatus, isFree, publishStatus, sale, isOnSpotlight, category, format) {
        var url = '/discover/v2';
        var params = [];
        if (currentType > -1)
            params.push('type=' + currentType);
        if (currentSort > -1)
            params.push('sort=' + currentSort);
        if ((currentGenre === null || currentGenre === void 0 ? void 0 : currentGenre.length) > 0)
            params.push('genreIds=' + currentGenre);
        if (subCategory !== '')
            params.push('subCategory=' + subCategory);
        params.push('includeSeries=' + includeSeries);
        if (widths > -1)
            params.push('widths=' + widths);
        if (scheduleStatus > -1)
            params.push('scheduleStatus=' + scheduleStatus);
        if (newOnly)
            params.push('newOnly=' + newOnly);
        if (isFree)
            params.push('isFree=' + isFree);
        if ((ageRatings === null || ageRatings === void 0 ? void 0 : ageRatings.length) > 0)
            params.push('ageRatings=' + ageRatings);
        if (seriesStatus > -1)
            params.push('seriesStatus=' + seriesStatus);
        if (publishStatus > -1)
            params.push('publishStatus=' + publishStatus);
        if (sale)
            params.push('isOnSale=' + sale);
        if (isOnSpotlight)
            params.push('showSpotLightInfo=' + isOnSpotlight);
        if (category)
            params.push('category=' + category);
        if (format > -1)
            params.push('distributionType=' + format);
        if (start != null) {
            params.push("fromIndex=".concat(start.valueOf()));
            if (count && count > -1)
                params.push("count=".concat(count.valueOf()));
        }
        if (params.length > 0) {
            url += '?' + params.filter(function (p) { return !p.endsWith("null"); }).join('&');
        }
        Log.debug('aaa ' + url);
        return this.getResponse(url, cancelTokenSource);
    };
    InkyAPI.prototype.getDiscoverSeries = function (currentType, currentSort, currentGenre, cancelTokenSource, start, count, widths) {
        var url = '/discover/series';
        var params = [];
        if (currentType > -1)
            params.push('type=' + currentType);
        if (currentSort > -1)
            params.push('sort=' + currentSort);
        if (currentGenre > -1)
            params.push('genre=' + currentGenre);
        if (widths > -1)
            params.push('widths=' + widths);
        if (start != null) {
            params.push("fromIndex=".concat(start.valueOf()));
            params.push("count=".concat(count.valueOf()));
        }
        if (params.length > 0) {
            url += '?' + params.filter(function (p) { return !p.endsWith("null"); }).join('&');
        }
        return this.get(url, cancelTokenSource);
    };
    InkyAPI.prototype.getDiscoverByID = function (id, cancelTokenSource, fromIndex, count, widths) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = [];
                        if (fromIndex) {
                            params.push(['fromIndex', '' + fromIndex]);
                        }
                        if (count) {
                            params.push(['count', '' + count]);
                        }
                        if (widths) {
                            params.push(['widths', widths]);
                        }
                        return [4 /*yield*/, this.getResponse('/discover/' + id, cancelTokenSource, params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    InkyAPI.prototype.getSeriesTypes = function (cancelTokenSource) {
        return this.get('/type', cancelTokenSource);
    };
    InkyAPI.prototype.getSeriesGenres = function (cancelTokenSource) {
        return this.get('/genre', cancelTokenSource);
    };
    InkyAPI.prototype.getAllGenres = function (cancelTokenSource) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.get('/genre', cancelTokenSource)];
            });
        });
    };
    InkyAPI.prototype.getSortOrders = function (cancelTokenSource) {
        return this.get('/discover/sortorder', cancelTokenSource);
    };
    InkyAPI.prototype.getSeries = function (id, widths, cancelTokenSource) {
        var params = [];
        params.push(['widths', widths]);
        return this.get('/series/V2/' + id, cancelTokenSource, params);
    };
    InkyAPI.prototype.getComicsForSeries = function (seriesId, cancelTokenSource) {
        return this.get("/comic/forSeries/V3/".concat(seriesId, "?platform=web&widths=250,500"), cancelTokenSource);
    };
    InkyAPI.prototype.getProductsForSeries = function (seriesId, cancelTokenSource) {
        return __awaiter(this, void 0, void 0, function () {
            var productDTO;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get("/product/forSeries/".concat(seriesId, "?platform=web&widths=250,500"), cancelTokenSource)];
                    case 1:
                        productDTO = _a.sent();
                        return [2 /*return*/, productDTO.data.map(function (x) { return Product.createFromApi(x); })];
                }
            });
        });
    };
    InkyAPI.prototype.getComics = function (seriesIds, cancelTokenSource) {
        return this.postV2("/comic/fetch-list/?widths=250,500", JSON.stringify(seriesIds), cancelTokenSource);
    };
    InkyAPI.prototype.getComicByID = function (id, cancelTokenSource) {
        return this.get('/comic/' + id, cancelTokenSource);
    };
    /* IP Tags */
    InkyAPI.prototype.getIPTags = function (cancelTokenSource) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getResponse('/iptag/', cancelTokenSource)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    InkyAPI.prototype.getIPTagByID = function (id, cancelTokenSource) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getResponse('/iptag/' + id, cancelTokenSource)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    InkyAPI.prototype.getMerchByID = function (id, cancelTokenSource) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getResponse('/product/' + id, cancelTokenSource)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    InkyAPI.prototype.getProductById = function (id, cancelTokenSource, width) {
        if (width === void 0) { width = null; }
        return __awaiter(this, void 0, void 0, function () {
            var params, apiResponse, product, e_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = [];
                        if (width != null) {
                            params.push(['widths', width]);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getData('/product/' + id, params)];
                    case 2:
                        apiResponse = _a.sent();
                        product = Product.createFromApi(apiResponse);
                        return [2 /*return*/, product];
                    case 3:
                        e_8 = _a.sent();
                        if (e_8 instanceof InkyApiError) {
                            throw e_8; // Pass it down
                        }
                        else {
                            throw new Error(e_8);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /* BUNDLES */
    InkyAPI.prototype.getBundleComics = function (bundleId, cancelTokenSource) {
        return this.get('/comic/forBundle/' + bundleId, cancelTokenSource);
    };
    InkyAPI.prototype.getBundles = function (cancelTokenSource) {
        return this.get('/discover/bundles/', cancelTokenSource);
    };
    /* ORDER CONFIRMATION */
    InkyAPI.prototype.getUserOrder = function (cancelTokenSource, orderId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getResponse('/order/' + orderId.toString(), cancelTokenSource)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    InkyAPI.prototype.getUserOrders = function (cancelTokenSource) {
        return __awaiter(this, void 0, void 0, function () {
            var orders, apiResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        orders = [];
                        apiResponse = this.getResponse('/order/', cancelTokenSource);
                        return [4 /*yield*/, apiResponse.then(function (x) {
                                console.debug('API: Successfully recieved shippingRates', x);
                                orders = x.response.map(function (x) { return Order.createFromApi(x); });
                                console.debug('Shipping Rates are', orders);
                            }).catch(function (e) {
                                console.error('[InkyAPI:getUserOrders] API-error:', e);
                                orders = [];
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, orders];
                }
            });
        });
    };
    InkyAPI.prototype.getAccountPageOrders = function (cancelTokenSource, maxItemCount, first) {
        return __awaiter(this, void 0, void 0, function () {
            var params, orders, amount, apiResponse, value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = [];
                        if (maxItemCount) {
                            params.push(['maxItemCount', '' + maxItemCount]);
                        }
                        if (first) {
                            params.push(['first', '' + first]);
                        }
                        orders = [];
                        amount = 0;
                        apiResponse = this.getResponse('/order/', cancelTokenSource, params);
                        return [4 /*yield*/, apiResponse.then(function (x) {
                                console.debug('API: Successfully recieved shippingRates', x);
                                orders = x.response.map(function (x) { return Order.createFromApi(x); });
                                amount = x.status.fullCount;
                            }).catch(function (e) {
                                console.error('[InkyAPI:getAccountPageOrders] API-error:', e);
                                orders = [];
                            })];
                    case 1:
                        _a.sent();
                        value = new OrdersCount();
                        value.Orders = orders;
                        value.Count = amount;
                        return [2 /*return*/, value];
                }
            });
        });
    };
    /* NEWS */
    InkyAPI.prototype.getNews = function (cancelTokenSource, maxItemCount, first, widths) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = [['pageType', 'News']];
                        if (maxItemCount) {
                            params.push(['maxItemCount', '' + maxItemCount]);
                        }
                        if (first) {
                            params.push(['first', '' + first]);
                        }
                        if (widths) {
                            params.push(['widths', '' + widths]);
                        }
                        return [4 /*yield*/, this.getResponse('/news', cancelTokenSource, params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    InkyAPI.prototype.getNewsV2 = function (maxItemCount, first, widths, sort) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = [['pageType', 'News']];
                        if (maxItemCount) {
                            params.push(['maxItemCount', '' + maxItemCount]);
                        }
                        if (first) {
                            params.push(['first', '' + first]);
                        }
                        if (widths) {
                            params.push(['widths', '' + widths]);
                        }
                        if (sort) {
                            params.push(['sort', '' + sort]);
                        }
                        Log.debug('getNewsV2', params);
                        return [4 /*yield*/, this.getResponse('/news', null, params)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.response];
                }
            });
        });
    };
    InkyAPI.prototype.getArticle = function (articleId, widths) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = [];
                        if (widths) {
                            params.push(['widths', '' + widths]);
                        }
                        return [4 /*yield*/, this.getResponse("news/strips-article/".concat(articleId), null, params)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Article.createFromApi(response.response)];
                }
            });
        });
    };
    InkyAPI.prototype.getSpotlightSeries = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('dashboard/spotlight', null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.newSpotlightSeries = function (spotlight) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post('/dashboard/spotlight/new', spotlight, null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.editSpotlightSeries = function (spotlight) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post('/dashboard/spotlight/alter', spotlight, null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.publishSpotlightSeries = function (spotlight) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post('/dashboard/spotlight/publish?id=' + spotlight.id, null, null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.unPublishSpotlightSeries = function (spotlight) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post('/dashboard/spotlight/unpublish?id=' + spotlight.id, null, null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.removeSpotLightSeries = function (spotlight) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post('/dashboard/spotlight/remove?id=' + spotlight.id, null, null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.getHeroBanner = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/herobanner', null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.getHeroBannerDashboard = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/dashboard/herobanner', null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.updateHeroBanner = function (hero) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post('/dashboard/herobanner/update', hero, null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.getUserBadges = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/userbadge/get', null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.getAllUserBadges = function (abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getV4('/dashboard/userbadge', abortSignal)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.alterUserBadge = function (payload, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postV4('/dashboard/userbadge/alter', payload, abortSignal)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.createNewUserBadge = function (payload, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postV4('/dashboard/userbadge/create', payload, abortSignal)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.claimUserBadge = function (badgeId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post('/userbadge/claim?badgeId=' + badgeId, null, null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.checkClaimComics = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/userbadge/has/ax?userId=' + userId, null, null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InkyAPI.prototype.ClaimAxComics = function (userId, email) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post('/userbadge/claim/ax?userId=' + userId + '&email=' + email, null, null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /* UPLOAD XML TRILOGY EXPORTS */
    InkyAPI.prototype.ValidateTrilogyExport = function (form, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postV4("/dashboard/trilogy-import/validate", form, abortSignal)];
                    case 1:
                        response = _a.sent();
                        if (response.status.type === "Success") {
                            return [2 /*return*/, response.response];
                        }
                        else {
                            throw new InkyApiError(response.status.message, InkyApiStatus.Default);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    InkyAPI.prototype.ValidateAndMergeTrilogyExport = function (form, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postV4("/dashboard/trilogy-import/validateAndMerge", form, abortSignal)];
                    case 1:
                        response = _a.sent();
                        if (response.status.type === "Success") {
                            return [2 /*return*/, response.response];
                        }
                        else {
                            throw new InkyApiError("Something Failed with ValidateTrilogyExport endpoint", InkyApiStatus.Default);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /* SEARCH */
    InkyAPI.prototype.search = function (query, cancelTokenSource) {
        return this.getResponse("/search/V3?query=".concat(query, "&platform=web"), cancelTokenSource);
    };
    InkyAPI.prototype.searchAndCancel = function (query, cancelTokenSource) {
        var cancelToken = Axios.CancelToken.source();
        return {
            res: this.getResponse("/search/V3?query=".concat(query, "&platform=web&showSpotLightInfo=true"), cancelToken), controller: cancelToken,
        };
    };
    InkyAPI.prototype.searchSuggestions = function (query, cancelTokenSource) {
        return this.get('/search/suggestions/' + query + '?field=series', cancelTokenSource);
    };
    /* ACCOUNT */
    InkyAPI.prototype.account = function (cancelTokenSource) {
        return this.getV2('/account');
    };
    InkyAPI.prototype.getAccountInfo = function (accessToken) {
        if (accessToken === void 0) { accessToken = null; }
        return this.getV3('/account', accessToken);
    };
    InkyAPI.prototype.setAccountSetting = function (key, value, cancelTokenSource) {
        return this.post("/account/settings/".concat(key), new AccountSetting(key, value), cancelTokenSource);
    };
    InkyAPI.prototype.resetPassword = function (cancelTokenSource) {
        return this.post('/account/resetPassword', null, cancelTokenSource);
    };
    InkyAPI.prototype.forgotPassword = function (email) {
        Log.debug(email);
        return this.post("/account/forgotPassword?email=".concat(email), null, null);
    };
    InkyAPI.prototype.changePassword = function (password) {
        Log.debug('inky-api password', password);
        return this.post('/account/changePassword?password=' + password, null, null);
    };
    InkyAPI.prototype.sendEvent = function (accountInfo, analyticsEvent) {
        var userId = 0; //Default if no user
        if (accountInfo !== null) {
            userId = accountInfo.userid;
            analyticsEvent.userId = userId;
            if (userId == 0) {
                analyticsEvent.userId = null;
            }
        }
        return this.post('/analytics/sendEvent', analyticsEvent, null);
    };
    InkyAPI.prototype.sendReaderEvent = function (accountInfo, analyticsReaderEvent) {
        var userId = 0; //Default if no user
        if (accountInfo !== null) {
            userId = accountInfo.userid;
            analyticsReaderEvent.userId = userId;
            if (userId == 0) {
                analyticsReaderEvent.userId = null;
            }
        }
        return this.post('/analytics/sendReaderEvent', analyticsReaderEvent, null);
    };
    InkyAPI.prototype.resendVerification = function (cancelTokenSource) {
        return this.post('/account/resendVerification', null, cancelTokenSource);
    };
    InkyAPI.prototype.validateUserPassword = function (email, password) {
        return this.post('/account/token', { UserName: email, Password: password });
    };
    InkyAPI.prototype.login = function (email, password) {
        return this.post('/account/token', { UserName: email, Password: password })
            .then(function (res) {
            Log.debug('login', res.data);
            var data = res.data;
            return data;
        });
    };
    InkyAPI.prototype.refresh = function (refreshToken) {
        return this.post('/account/token', { refresh_token: refreshToken })
            .then(function (res) {
            Log.debug('Refresh response received..');
            var data = res.data;
            return data;
        });
    };
    InkyAPI.prototype.signup = function (userDetails) {
        return this.post('/account/signupCustomer', userDetails).then(function (res) {
            Log.debug('Signup response received..');
            Log.debug('Signup result:' + res.status);
            if (res.status === 200) {
                return res.status;
            }
            else {
                Log.debug('signup.failed.');
            }
        });
    };
    InkyAPI.prototype.registerCartData = function (cancelTokenSource, json) {
        return this.post('/analytics/updateCart', { json: json }, cancelTokenSource);
    };
    /* INSTRUMENTATION */
    InkyAPI.prototype.sendInstrumentationData = function (data, cancelTokenSource) {
        return this.post('/account/instrumentation', data, cancelTokenSource);
    };
    return InkyAPI;
}());
var apiClient = new InkyAPI();
export default apiClient;
